import React from 'react';
import styles from './style.module.css';
import StepFourForm from '../../components/forms/step-four';

export default () => (
    <div className={styles.page}>
        <p className={styles.topTitle}>Loan Intro Title</p>
        <h1 className={styles.mainTitle}>Payment Frequency</h1>
        <p className={styles.text}>Content relating to the payment frequency.</p>
        <StepFourForm/>
    </div>
);
